// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bronze[data-v-0aaef874]{color:#b06d50}.silver[data-v-0aaef874]{color:silver}.gold[data-v-0aaef874]{color:#d1a60b}.rarity-icon[data-v-0aaef874]{height:18px;width:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
